<!-- 详情弹框框 -->
<template>
  <div>
    <el-dialog
      width="80%"
      destroy-on-close
      append-to-body
      custom-class="show-dialog"
      :visible.sync="showDialog"
      :title="$t('text.nbqxq')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      @open="getDetail"
    >

      <el-scrollbar style="height:100%">
        <el-form v-loading="loading" label-width="190px" class="show-form">
          <!-- 报警字状态字 -->
          <el-divider content-position="left">{{ $t('text.bjztz') }}</el-divider>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.nbqsn')">
                <span>{{ detail| objValue('sn') | nullFilter }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.nbqzt')">
                <span>{{ detail| objValue('status') | statusDFilter }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.bjxx')">
                <span>{{ detail| objValue('alarm') | nullFilter }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.bjsj')">
                <span>{{ detail| objValue('alarmTime') | dateFilter('yyyy-MM-dd hh:mm:ss') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 网侧信息 -->
          <el-divider content-position="left">{{ $t('dialog.wcxx') }}</el-divider>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.axdy')">
                <span>{{ detail.reals | objValue(['nlua']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.bxdy')">
                <span>{{ detail.reals | objValue(['nlub']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.cxdy')">
                <span>{{ detail.reals | objValue(['nluc']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pl')">
                <span>{{ detail.reals | objValue(['nfrq']) | unit('Hz') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.axdl')">
                <span>{{ detail.reals | objValue(['nlia']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.bxdl')">
                <span>{{ detail.reals | objValue(['nlib']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.cxdl')">
                <span>{{ detail.reals | objValue(['nlic']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.nbqwd')">
                <span>{{ detail.reals | objValue(['ninvtemper']) | unit('℃') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.axgl')">
                <span>{{ detail.reals | objValue(['npa']) | unit('w') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.bxgl')">
                <span>{{ detail.reals | objValue(['npb']) | unit('w') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.cxgl')">
                <span>{{ detail.reals | objValue(['npc']) | unit('w') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.hjwd')">
                <span>{{ detail.reals | objValue(['nenvtemper']) | unit('℃') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 负载侧信息 -->
          <el-divider content-position="left">{{ $t('dialog.fzcxx') }}</el-divider>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.axfzdy')">
                <span>{{ detail.reals | objValue(['flua']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.bxfzdy')">
                <span>{{ detail.reals | objValue(['flub']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.cxfzdy')">
                <span>{{ detail.reals | objValue(['fluc']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.axfzl')">
                <span>{{ detail.reals | objValue(['fra']) | unit('%') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.axfzdl')">
                <span>{{ detail.reals | objValue(['fia']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.bxfzdl')">
                <span>{{ detail.reals | objValue(['fib']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.cxfzdl')">
                <span>{{ detail.reals | objValue(['fic']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.bxfzl')">
                <span>{{ detail.reals | objValue(['frb']) | unit('%') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.axfzgl')">
                <span>{{ detail.reals | objValue(['fpa']) | unit('w') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.bxfzgl')">
                <span>{{ detail.reals | objValue(['fpb']) | unit('w') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.cxfzgl')">
                <span>{{ detail.reals | objValue(['fpc']) | unit('w') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.cxfzl')">
                <span>{{ detail.reals | objValue(['frc']) | unit('%') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 电池侧信息 -->
          <el-divider content-position="left">{{ $t('dialog.dccxx') }}</el-divider>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dcdl')">
                <span>{{ detail.reals | objValue(['bi']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dcdl1')">
                <span>{{ detail.reals | objValue(['bi1']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dcdl2')">
                <span>{{ detail.reals | objValue(['bi2']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dcdl3')">
                <span>{{ detail.reals | objValue(['bi3']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dcsydl')">
                <span>{{ detail.reals | objValue(['bsoc']) | unit('%') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dcwd')">
                <span>{{ detail.reals | objValue(['bmscelltemper']) | unit('℃') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.cddy')">
                <span>{{ detail.reals | objValue(['bmsucharge']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.cdxlz')">
                <span>{{ detail.reals | objValue(['bmslicharge']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.fdxlz')">
                <span>{{ detail.reals | objValue(['bmslidischarge']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dcdy')">
                <span>{{ detail.reals | objValue(['bu']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- PV侧信息 -->
          <el-divider content-position="left">{{ $t('dialog.pvcxx') }}</el-divider>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv1dy')">
                <span>{{ detail.reals | objValue(['upv1']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv2dy')">
                <span>{{ detail.reals | objValue(['upv2']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv3dy')">
                <span>{{ detail.reals | objValue(['upv3']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv4dy')">
                <span>{{ detail.reals | objValue(['upv4']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv1dl')">
                <span>{{ detail.reals | objValue(['ipv1']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv2dl')">
                <span>{{ detail.reals | objValue(['ipv2']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv3dl')">
                <span>{{ detail.reals | objValue(['ipv3']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv4dl')">
                <span>{{ detail.reals | objValue(['ipv4']) | unit('A') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv1gl')">
                <span>{{ detail.reals | objValue(['ppv1']) | unit('W') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv2gl')">
                <span>{{ detail.reals | objValue(['ppv2']) | unit('W') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv3gl')">
                <span>{{ detail.reals | objValue(['ppv3']) | unit('W') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.pv4gl')">
                <span>{{ detail.reals | objValue(['ppv4']) | unit('W') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 整机模拟量 -->
          <el-divider content-position="left">{{ $t('dialog.zjmnl') }}</el-divider>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.zbus')">
                <span>{{ detail.reals | objValue(['invfubus']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.fbus')">
                <span>{{ detail.reals | objValue(['invrubus']) | unit('V') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dcwendu')">
                <span>{{ detail.reals | objValue(['invdctemper']) | unit('℃') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.drfadl')">
                <span>{{ detail.reals | objValue(['fetoday']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dyfadl')">
                <span>{{ detail.reals | objValue(['femonth']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dnfadl')">
                <span>{{ detail.reals | objValue(['feyear']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.zfadl')">
                <span>{{ detail.reals | objValue(['fetotal']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.drfdl')">
                <span>{{ detail.reals | objValue(['retoday']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dyfdl')">
                <span>{{ detail.reals | objValue(['remonth']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dnfdl')">
                <span>{{ detail.reals | objValue(['reyear']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.zfdl')">
                <span>{{ detail.reals | objValue(['retotal']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.drhdl')">
                <span>{{ detail.reals | objValue(['cetoday']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dyhdl')" label-width="191px">
                <span>{{ detail.reals | objValue(['cemonth']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.dnhdl')">
                <span>{{ detail.reals | objValue(['ceyear']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('dialog.zhdl')">
                <span>{{ detail.reals | objValue(['cetotal']) | unit('kW') }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </el-dialog>

  </div>
</template>

<script>
import { GetRealDetails } from '@apis/Stations.js'
export default {
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    propId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      detail: {
        reals: {}
      }
    }
  },
  methods: {
    getDetail () {
      this.loading = true
      GetRealDetails({
        id: this.propId
      })
        .then(res => {
          this.loading = false
          this.detail = res.data || {}
        })
    },
    handleClose () {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
<style lang='stylus' scoped>
.el-form-item
  margin-bottom 10px
</style>
<style lang="stylus">
.show-dialog .el-dialog__body
  height calc(70vh - 54px - 60px )
</style>
